import { useEffect, useRef, useState } from 'react';
import { getImages } from '../Const';

const CustomDropdown = ({ user, theme, toggleTheme, logout }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="btn-group custom-dropdown header-custom-dropdown position-relative ms-3" ref={dropdownRef}>
      <button
        type="button"
        className="btn btn-secondary dropdown-toggle"
        onClick={() => setOpen(prev => !prev)}
      >
        <img src={getImages('user-icon.svg')} alt="user" /> Welcome {user && user.first_name}
      </button>

      {open && (
        <div className="dropdown-menu show dropdown-menu-end">
          <button
            className="dropdown-item text-uppercase text-dblue"
            type="button"
            onClick={() => {
              logout();
              setOpen(false);
            }}
          >
            Logout
          </button>
          <div className="dropdown-item">
            <div className='d-flex align-items-center justify-content-between'>
              <div className='text-capitalize'>{theme} Theme</div>
              <div>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={theme === 'light'}
                    onChange={toggleTheme}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
